module.exports = __webpack_public_path__ + "img/image-thumb-16.3a99a949.webp";